import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import axios from "axios";
import BookingDialog from "@/components/landing/BookingDialog";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const DEFAULT_BUSINESS = {
  name: "TechConnect LLC",
  phone: "(919) 737-5442",
  phoneTel: "+19197375442",
  email: "techconnectncllc@gmail.com",
  city: "Clayton & Granite Falls, NC",
  locations: [
    {
      slug: "clayton",
      name: "TechConnect LLC – Clayton",
      street: "5720 US 70 Bus Hwy, Suite B",
      city: "Clayton",
      state: "NC",
      zip: "27520",
      phone: "(919) 737-5442",
      phoneTel: "+19197375442",
      serves: ["Clayton", "Smithfield", "Garner", "Raleigh", "Knightdale", "Wendell", "Fuquay-Varina", "Cary", "Durham", "Chapel Hill"],
    },
    {
      slug: "granite-falls",
      name: "TechConnect LLC – Granite Falls",
      street: "10A Falls Avenue",
      city: "Granite Falls",
      state: "NC",
      zip: "28630",
      phone: "(919) 737-5442",
      phoneTel: "+19197375442",
      serves: ["Granite Falls", "Hickory", "Lenoir", "Morganton", "Newton", "Conover"],
    },
  ],
};

const BookingContext = createContext({
  business: DEFAULT_BUSINESS,
  open: false,
  service: "",
  openBooking: () => {},
  closeBooking: () => {},
});

export function BookingProvider({ children }) {
  const [business, setBusiness] = useState(DEFAULT_BUSINESS);
  const [open, setOpen] = useState(false);
  const [service, setService] = useState("");

  useEffect(() => {
    axios.get(`${API}/business`).then((r) => setBusiness(r.data)).catch(() => {});
  }, []);

  const openBooking = useCallback((svc = "") => {
    setService(svc || "");
    setOpen(true);
  }, []);

  const closeBooking = useCallback(() => setOpen(false), []);

  return (
    <BookingContext.Provider value={{ business, open, service, openBooking, closeBooking }}>
      {children}
      <BookingDialog open={open} onOpenChange={setOpen} defaultService={service} />
    </BookingContext.Provider>
  );
}

export function useBooking() {
  return useContext(BookingContext);
}
